var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.776 5.833a.751.751 0 0 1 1.177.916l-.044.064-2.123 2.727 2.123 2.73a.75.75 0 0 1-1.133.979l-.05-.059-1.889-2.428-1.889 2.428-.05.059a.75.75 0 0 1-1.133-.98L9.887 9.54 7.765 6.813l-.044-.064a.75.75 0 0 1 1.178-.916l.05.058 1.888 2.427 1.889-2.427z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.41 2.587a.75.75 0 0 1 0 1.492l-.077.004H8.652c-.5 0-.952.298-1.149.758l-3.48 8.12a.75.75 0 0 1-1.346.07l-1.666-3a.75.75 0 0 1 1.31-.73l.924 1.664 2.88-6.715a2.75 2.75 0 0 1 2.527-1.667h5.681z"
  })));
};
export default Svg16;